import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Table, TableColumnsType, TableProps, Switch } from "antd";
import withBrowserPurchaseRequestLogic from "../../components/hoc_browser_purchase_request";
import useSWR from "swr";
import axios from "axios";

const fetcher = (url: string) => axios.get(url).then(res => res.data);

interface PurchaseRequestData {
    key: React.Key;
    id: number;
    pr_no: string;
    pr_date_formatted: string;
    item_group?: string;
    order_type?: string;
    reference_no?: string;
    arrival_date_formatted?: string;
    po_no?: string;
    dealer_rep_code?: string;
    status: string;
    set_order: string;
    back_order: string;
}

interface BrowserPurchaseRequestProps {
    columns?: TableColumnsType<PurchaseRequestData>;
    data?: PurchaseRequestData[];
    isLoading?: boolean;
    onRow?: TableProps<PurchaseRequestData>['onRow'];
    pagination?: TableProps<PurchaseRequestData>['pagination'];
    showAllWarehouse?: boolean;
    setShowAllWarehouse?: (val: boolean) => void;
    hasOtoritas77?: boolean;
}

const BrowserPurchaseRequest: React.FC<BrowserPurchaseRequestProps> = ({
    columns,
    data,
    isLoading,
    onRow,
    pagination,
    showAllWarehouse,
    setShowAllWarehouse,
    hasOtoritas77
}) => {

    const { data: orderTypes } = useSWR(`${process.env.REACT_APP_BACKEND_URL}/api/order-types`, fetcher);
    const { data: warehouses } = useSWR(`${process.env.REACT_APP_BACKEND_URL}/api/dealers`, fetcher);
    const itemGroupMap: Record<string, string> = { "001": "Inventory", "002": "Out Side Job", "": "-- Empty --" };
    const orderTypeFilters = orderTypes?.map((t: any) => ({ text: t.label, value: t.value })) || [];
    const warehouseFilters = warehouses?.map((w: any) => ({ text: w.warehouse_name, value: w.warehouse_code })) || [];
    const statusFilters = [{ text: 'Draft', value: 'Draft' }, { text: 'Ready', value: 'Ready' }, { text: 'Canceled', value: 'Canceled' }, { text: 'Closed', value: 'Closed' }, { text: 'Close / Complete', value: 'Close / Complete' }];
    const renderedColumns = columns?.map((col: any) => {
        if (col.dataIndex === 'order_type') return { ...col, filterDropdown: undefined, filterIcon: undefined, filters: orderTypeFilters, onFilter: (value: any, record: any) => record.order_type === value, render: (v: string) => orderTypes?.find((t: any) => t.value === v)?.label || v };
        if (col.title === 'Warehouse' || col.dataIndex === 'dealer_rep_code' || col.dataIndex === 'warehouse') return { ...col, filterDropdown: undefined, filterIcon: undefined, filters: warehouseFilters, onFilter: (value: any, record: any) => (record.dealer_rep_code || record.warehouse) === value, render: (v: string) => warehouses?.find((w: any) => w.warehouse_code === v)?.warehouse_name || v };
        if (col.title === 'Status' || col.dataIndex === 'status') return { ...col, filterDropdown: undefined, filterIcon: undefined, filters: statusFilters, onFilter: (value: any, record: any) => record.status === value };
        return col;
    });

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="iq33">
                <div className="gjs-grid-column" id="i8hj">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_purchase_request",
                                title: (
                                    <>
                                        <span>Data Purchase Request</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/purchase_request",
                                title: "Purchase Request",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="ija1">
                <div className="gjs-grid-column" id="iejz">
                    {hasOtoritas77 && (
                        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Switch checked={showAllWarehouse} onChange={setShowAllWarehouse} />
                            <span style={{ fontSize: '14px' }}>Show All Warehouse</span>
                        </div>
                    )}
                    <Table<PurchaseRequestData>
                        columns={renderedColumns}
                        dataSource={Array.isArray(data) ? data : (data as any)?.data || []}
                        loading={isLoading}
                        scroll={{ x: 1300 }}
                        rowKey="key"
                        onRow={onRow}
                        pagination={pagination}
                    />
                </div>
            </div>
        </div>
    );
};

export default withBrowserPurchaseRequestLogic(BrowserPurchaseRequest);